import RequestQuoteIcon from '@mui/icons-material/RequestQuoteOutlined';

const MaterialRequestQuoteIcon = (props) => {
  return <RequestQuoteIcon htmlColor="#1F1f1f" {...props} />;
};

export default MaterialRequestQuoteIcon;
